<!-- =========================================================================================
    File Name: EditPlacementAnchor.vue
    Description: Card component to see the name of the object and button to edit and delete it.
========================================================================================== -->

<template>
  <div>
    <vx-tooltip :key="refrehHackIndex" :enable="hobject.name.length > 30" delay=".5s" :text="hobject.name">
      <vx-card
        v-if="mainNode"
        class="custom-card mt-2"
        :card-background="getCardColor(mainNode, selectedNode)"
        v-on:click="parent.setSelectedNode(mainNode)"
        :title="hobject.name | truncate(30)"
      >
        <template slot="actions">
          <feather-icon
            v-if="
              mainNode &&
                getAnchor(mainNode) &&
                (getAnchor(mainNode).anchor_type == 'image' ||
                  getAnchor(mainNode).anchor_type == 'vuforia-instant-image-target')
            "
            v-on:click="parent.editAnchor(mainNode.anchor_pid)"
            icon="AnchorIcon"
            svgClasses="w-6 h-6 text-grey"
          ></feather-icon>
          <feather-icon
            v-on:click="setEditPanelVisible(mainNode)"
            class="ml-5"
            :icon="mainNode.isEditPanelVisible ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            svgClasses="w-6 h-6 text-grey"
          ></feather-icon>
          <feather-icon
            v-on:click="parent.editHobject(mainNode.hobject_pid)"
            class="ml-5"
            icon="Edit2Icon"
            svgClasses="w-6 h-6 text-grey"
          ></feather-icon>
          <!-- <feather-icon
          v-if="getAnchor(mainNode)"
          v-on:click="parent.cloneNode(mainNode)"
          class="ml-5"
          icon="CopyIcon"
          svgClasses="w-6 h-6 text-grey"
        ></feather-icon> -->
          &nbsp;
          <feather-icon
            v-on:click="parent.confirmRemoveNode(mainNode.pid)"
            icon="TrashIcon"
            svgClasses="w-6 h-6 text-grey"
          ></feather-icon>
        </template>
        <div v-if="isEditPanelVisible(mainNode)">
          <div class="vx-row">
            <div class="vx-col w-1/3">
              <vs-input
                type="number"
                v-validate="'decimal'"
                label="position x"
                name="decimal"
                size="small"
                v-on:input="onInput(mainNode)"
                v-model.number="mainNode.x"
                class="w-full"
              />
            </div>
            <div class="vx-col w-1/3">
              <vs-input
                v-validate="'decimal'"
                type="number"
                label="position y"
                name="decimal"
                size="small"
                v-on:input="onInput(mainNode)"
                v-model.number="mainNode.y"
                class="w-full"
              />
            </div>
            <div class="vx-col w-1/3">
              <vs-input
                v-validate="'decimal'"
                type="number"
                label="position z"
                name="decimal"
                size="small"
                v-on:input="onInput(mainNode)"
                v-model.number="mainNode.z"
                class=" w-full"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/3">
              <vs-input
                label="rotation x"
                type="number"
                size="small"
                v-on:input="onInput(mainNode)"
                v-model.number="mainNode.angle_x"
                class=" w-full"
              />
            </div>
            <div class="vx-col w-1/3">
              <vs-input
                label="rotation y"
                type="number"
                size="small"
                v-on:input="onInput(mainNode)"
                v-model.number="mainNode.angle_y"
                class=" w-full"
              />
            </div>
            <div class="vx-col w-1/3">
              <vs-input
                label="rotation z"
                type="number"
                size="small"
                v-on:input="onInput(mainNode)"
                v-model.number="mainNode.angle_z"
                class=" w-full"
              />
            </div>
            <div class="vx-col w-1/3">
              <vs-input
                type="number"
                label="scale"
                size="small"
                v-on:input="onInput(mainNode)"
                v-model.number="mainNode.scale"
                class="w-full"
              />
            </div>
          </div>
        </div>
      </vx-card>
    </vx-tooltip>
    <div v-if="nodesWithSameHobject">
      <div v-for="node in nodesWithSameHobject" v-bind:key="node.pid">
        <vx-card
          v-if="node.pid != mainNode.pid"
          class="clone-card custom-card mt-2 mr-6"
          v-on:click="parent.setSelectedNode(node)"
          :card-background="getCardColor(node, selectedNode)"
          :title="('Clone of ' + hobject.name) | truncate(25)"
        >
          <template slot="actions">
            <!-- {{ selectedNode.node }} -->
            <feather-icon
              v-on:click="parent.removeNode(node.pid)"
              icon="TrashIcon"
              svgClasses="w-6 h-6 text-grey"
            ></feather-icon>
          </template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import 'flatpickr/dist/flatpickr.css'

export default {
  props: {
    nodes: {},
    hobject: {},
    hobjects: {},
    anchors: {},
    selectedNode: {},
    mainNode: {},
    nodesWithSameHobject: {},
    // store old node value
    oldNodeValue: null,
  },
  components: {},
  data() {
    return {
      parent: this.$parent,
      backgroundColor: null,
      refrehHackIndex: 0,
    }
  },
  watch: {
    mainNode: {
      // This will let Vue know to look inside the object
      deep: true,
      // We have to move our method to a handler field
      handler() {},
    },
    nodes: function() {},
  },
  computed: {},
  async mounted() {
    // var element = document.getElementsByClassName('edit-placement-anchor-card')[0]
    // if (element) element.style.height = this.nodesWithSameHobject.length * 70 + 'px'
  },
  created() {},
  methods: {
    onInput(node) {
      this.$nextTick(() => {
        if (
          this.isNumeric(node.x) &&
          this.isNumeric(node.y) &&
          this.isNumeric(node.z) &&
          this.isNumeric(node.angle_x) &&
          this.isNumeric(node.angle_y) &&
          this.isNumeric(node.angle_z) &&
          this.isNumeric(node.scale)
        ) {
          this.$eventBus.$emit('nodePositionChanged', node)
        }
      })
    },
    getAnchor(node) {
      return this.anchors.find(anchor => anchor.pid == node.anchor_pid)
    },
    getHobjectNameFromNode(node) {
      var name = this.hobjects.find(hobject => hobject.pid == node.hobject_pid).name
      return name != null ? name : 'Unamed object'
    },
    setEditPanelVisible(node) {
      if (node.isEditPanelVisible == true) {
        node.isEditPanelVisible = false
      } else {
        node.isEditPanelVisible = true
      }
      this.refrehHackIndex++
    },
    isEditPanelVisible(node) {
      if (!node) return false
      if (node.isEditPanelVisible == true) return true
      else false
    },
    isCardSelected(node, selectedNode) {
      if (selectedNode && selectedNode.pid && node.pid == selectedNode.pid) return true
      else return false
    },
    getCardColor(node, selectedNode) {
      if (selectedNode && selectedNode.pid && node.pid == selectedNode.pid) return '#e9e7fd'
      else return '#FFFFFF'
    },
    isNumeric(n) {
      return (Number(n) === n && n % 1 === 0) || (Number(n) === n && n % 1 !== 0)
    },
  },
}
</script>

<style lang="scss">
.clone-card {
  width: 90%;
  left: 2rem;
}
.custom-card .vx-card__header {
  padding: 0.5rem;
}
.custom-card .vx-card__header .vx-card__title h4 {
  font-size: 16px;
  font-weight: 250;
}
</style>
